import React from 'react';
import { useStyles } from './ItemsList.styles';
var ItemsList = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return React.createElement("div", { className: classes.container }, children);
};
export { ItemsList };
